<template>
  <div class="bg-mist rounded p-4 grid gap-2 md:gap-2 md:flex md:items-center">
    <div class="grid gap-2 flex-1">
      <div class="grid gap-1">
        <p class="font-bold text-lg md:text-xl" v-html="meal.name" />
        <!-- <div class="my-1 flex gap-4 text-[#888]">
          <div class="flex items-center gap-2">
            <AtomIcon name="user-group" class="w-4" />
            <div class="text-sm md:text-base" v-html="$t('shared.amount', fat.amount)" />
          </div>
          <div class="flex items-center gap-2">
            <AtomIcon name="calendar" class="w-4" />
            <div class="text-sm md:text-base" v-html="$dayjs(fat.date).format('dddd D MMMM')" />
          </div>
        </div> -->
        <div class="text-sm md:text-base line-clamp-3" v-html="meal.description" />
      </div>
    </div>
    <div class="text-sm">
      <button class="button-coral" @click="useOpenWidget(restaurant.hash, meal.id)" >
        {{ $t('shared.bookTable') }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
  meal: {
    type: Object,
    default: () => {}
  }
})
</script>